import styled from 'styled-components'

import TitleHeader from 'components/presenters/header/TitleHeader'

import SingupPage from 'pages/SingupPage'

export default function TestLayout() {
  return <SingupPage />
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (51 / 375));
`
